<div id="google_translate_element"></div>

<div class="site-wrapper debugx" [class.map]="activePath === 'categorie/:category/map'">
    <router-outlet></router-outlet>
</div>
